import { BsArrowRight } from "react-icons/bs";
import { deltaClass, money, pct, toChangePct } from "../utils";

const TotalSalesChangeCard = ({ totalSales }) => {
  const deltaPct =
    totalSales?.deltaPct !== null && totalSales?.deltaPct !== undefined
      ? totalSales.deltaPct
      : toChangePct(totalSales?.current, totalSales?.previous);

  return (
    <div className="card">
      <div className="opacity-70">Total Sales Change</div>
      <div className="text-xs opacity-60 mt-1">
        Overall revenue movement in the selected comparison window.
      </div>
      <div className="text-xl font-bold mt-1">
        {money(totalSales?.previous)} <BsArrowRight className="inline mx-1" />{" "}
        {money(totalSales?.current)}
      </div>
      <div className={`${deltaClass(totalSales?.delta)} mt-1`}>
        {pct(deltaPct)}
      </div>
    </div>
  );
};

export default TotalSalesChangeCard;
